import { z } from 'zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { ContactOps } from '@/features/contact-ops'

const contactOpsSearchSchema = z
  .object({
    branch: z.string().optional(),
    department: z.string().optional(),
    startDate: z.string().optional(),
    endDate: z.string().optional(),
    language: z.string().optional(),
  })
  .catch({})

export const Route = createFileRoute(
  '/_authenticated/new-vehicle/contact-ops/'
)({
  validateSearch: contactOpsSearchSchema,
  beforeLoad: ({ search }) => {
    if (!search?.language) {
      throw redirect({
        to: '/new-vehicle/contact-ops',
        search: {
          branch: search?.branch,
          department: search?.department,
          startDate: search?.startDate,
          endDate: search?.endDate,
          language: 'en',
        },
      })
    }
  },
  component: ContactOps,
})
